import axios from "axios";

// const API_URL = "http://localhost:3000/api/users";
const API_URL = `${process.env.VUE_APP_API_URL}/api/users`;

export async function login(email, password) {
  try {
    const res = await axios.post(`${API_URL}/login`, { email, password });
    const { value } = res.data;

    if (value?.id && value?.userRole) {
      localStorage.setItem("token", value.id); // ✅ temporary ID-based auth
      localStorage.setItem("userRole", value.userRole);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Login failed:", error);
    return false;
  }
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("userRole");
}

export function isAuthenticated() {
  return !!localStorage.getItem("token");
}
